module.exports = __webpack_public_path__ + "img/Contenedores reciclaje.8cdd7716.jpg";